import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getTraderMapCampaignDetail} from '../../../apis/tradermap_campaign/detail'

const useQueryTraderMapCampaignDetail = (id: string) => {
    const {data, refetch} = useQuery({
        queryKey: QueryCacheKeys.tradermap.getTraderMapCampaignDetail(id),
        queryFn: async () => {
            const {data} = await getTraderMapCampaignDetail(id)
            return data
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    })

    return {data: data, refetch}
}

export default useQueryTraderMapCampaignDetail
